<div class="modal d-block equipment-backdrop" *ngIf="isOpen" (click)="onBackdropClick($event)">
  <div class="modal-dialog modal-dialog-centered modal-lg" style="max-width: 64rem;" (click)="$event.stopPropagation()">
    <div class="modal-content rounded-5 shadow-lg border-0" style="border-radius: 20px;">
      <div class="modal-header border-0 pb-0">
        <h5 style="font-size: 2rem;" class="modal-title fw-semibold">Add New Instance</h5>
        <button type="button" style="border: none; background: transparent;" (click)="onCancel()" aria-label="Close">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect width="24" height="24" rx="12" fill="#171717" fill-opacity="0.05"/>
            <rect x="0.5" y="0.5" width="23" height="23" rx="11.5" stroke="#171717" stroke-opacity="0.07"/>
            <path d="M8.375 8.375L15.625 15.625M15.625 8.375L8.375 15.625" stroke="#171717" stroke-width="1.5" stroke-linecap="round"/>
          </svg>
        </button>
      </div>
      <div class="new-instance-modal-body modal-body pt-3 m-0 w-100 align-items-center justify-content-between">
        <div class="section w-100 row">
          <div class="label-div d-flex align-items-center justify-content-left col-6">
            <p>Parent Class (Substation)</p>
          </div>
          <div class="col-6">
            <lib-object-dropdown
                [items]="substationTemplateOptions"
                [displayField]="'className'"
                [initialValue]="substationTemplateValue"
                (valueChange)="onSelectSubstationTemplate($event)"
                [disabled]="false"
                [isRequired]="true"
                #substationTemplateDropdown
            ></lib-object-dropdown>
          </div>
          <div class="label-div d-flex align-items-center justify-content-left col-6 asset-spacing">
            <p>Asset Name</p>
          </div>
          <div class="col-6 asset-spacing" [ngClass]="{ 'disabled': selectedSubstationTemplateId === 0 }">
            <lib-object-dropdown
              [items]="substationOptions"
              [displayField]="'name'"
              [initialValue]="substationInstanceValue"
              (valueChange)="onSelectSubstationInstance($event)"
              [disabled]="false"
              [isRequired]="true"
              [isSearchEnabled]="true"
              [maxDisplayItemSize]="10"
              (searchTextChange)="onSearchTextChange($event)"
              #substationInstanceDropdown
            ></lib-object-dropdown>
          </div>
        </div>
      </div>

      <div class="modal-footer border-0">
        <button type="button" class="btn cancel-modal-btn" (click)="onCancel()">Cancel</button>
        <button type="button" class="btn save-modal-btn" (click)="onProceed()">Proceed</button>
      </div>
    </div>
  </div>
</div>
